import { apiClient } from './client';
import type { HarvestRecord, HarvestKpi } from '../types/api.types';

/** Harvest records for a lote */
export const fetchHarvestRecords = async (loteId: string, moduleId?: string): Promise<HarvestRecord[]> =>
  (await apiClient.get(`/api/lotes/${loteId}/harvests`, { params: moduleId ? { moduleId } : undefined })).data;

/** Aggregated harvest KPIs */
export const fetchHarvestKpi = async (loteId: string, moduleId?: string): Promise<HarvestKpi> =>
  (await apiClient.get(`/api/lotes/${loteId}/harvests/kpi`, { params: moduleId ? { moduleId } : undefined })).data;

/** Cross-lote summary for harvest page */
export const fetchHarvestSummary = async (ranchoId?: string | null, moduleId?: string): Promise<{
  records: HarvestRecord[];
  kpis:    HarvestKpi[];
}> => (await apiClient.get('/api/harvests/summary', { params: ranchoId || moduleId ? { ...(ranchoId ? { ranchoId } : {}), ...(moduleId ? { moduleId } : {}) } : undefined })).data;

export interface PackedBoxInput {
  calibre:  string;
  weightKg: number;
  boxCount: number;
  grade:    'A' | 'B' | 'C';
}

export interface CreateHarvestLogInput {
  batchId:        string;
  /** Zona o subzona donde se cosechó (opcional). */
  moduleId?:      string;
  boxes:          PackedBoxInput[];
  folioId?:       string;
  containerCode?: string;
  notes?:         string;
}

export const createHarvestLog = async (loteId: string, input: CreateHarvestLogInput): Promise<HarvestRecord> =>
  (await apiClient.post(`/api/lotes/${loteId}/harvests`, input)).data;

export interface LoteBatch {
  batchId:  string;
  packedAt: string;
}

/** Batches/ciclos de empaque existentes de un lote (más reciente primero) */
export const fetchLoteBatches = async (loteId: string): Promise<LoteBatch[]> =>
  (await apiClient.get(`/api/lotes/${loteId}/batches`)).data;
